import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

import Button from "../../../../components/Form/Button";

export const PageWrapper = styled("div")(() => ({
  display: "flex",
  height: "100%",
  width: "100%",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#FCFCFD",
}));

export const LoginForm = styled("form")(() => ({
  display: "flex",
  maxWidth: "442px",
  width: "100%",
  padding: "40px",
  flexDirection: "column",
  alignItems: "center",
  gap: "40px",
  borderRadius: "4px",
  borderTop: `4px solid ${colors.brandBlue500}`,
  background: "#FFF",
  boxShadow: "0px 1px 3px 0px rgba(71, 84, 103, 0.30), 0px 4px 8px 3px rgba(71, 84, 103, 0.15)",
  "@media screen and (max-width: 442px)": {
    height: "100%",
    justifyContent: "center",
  },
}));

export const LogoImage = styled("img")(() => ({
  maxHeight: 80,
  maxWidth: 352,
  "@media screen and (max-width: 442px)": {
    maxWidth: 280,
  },
}));

export const LoginInfo = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "12px",
  width: "100%",
}));

export const LoginTitle = styled("span")(() => ({
  color: "#475467",
  font: "500 32px Manrope",
  lineHeight: "44px",
  textAlign: "center",
}));

export const LoginSubtitle = styled("span")(() => ({
  color: "#475467",
  font: "400 16px Manrope",
  lineHeight: "24px",
  letterSpacing: "0.15px",
  textAlign: "center",
}));

export const TextLink = styled("span")(() => ({
  font: "600 14px Manrope",
  color: colors.brandBlue500,
  cursor: "pointer",
}));

export const ForgotFormWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "24px",
  width: "100%",
}));

export const ResendText = styled("span")(() => ({
  color: "#475467",
  font: "400 14px Manrope",
}));

export const ResendContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  gap: "4px",
  width: "100%",

  "@media screen and (max-width: 442px)": {
    flexDirection: "row",
  },
}));

export const ContainerFooter = styled("div")(() => ({
  position: "absolute",
  bottom: 0,
  width: "100%",
  background: "#FFF",
  boxShadow: "0px -4px 8px 0px rgba(228, 231, 236, 0.30)",
}));

export const GoBackToLoginButton = styled(Button)(() => ({
  backgroundColor: `${colors.brandBlue500} !important`,
  color: `${colors.white} !important`,
}));
export const ResetPasswordButton = styled(Button)(() => ({
  backgroundColor: `${colors.brandBlue500} !important`,
  color: "#FFFFFF !important",
}));

const styles = makeStyles(() => ({
  label: {
    color: colors.brandBlue500,
  },
}));

export default styles;
